import Vue from 'vue'
import Vuex from 'vuex'
import * as d3 from 'd3'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    count: 0,
    records: [],
    brRecords: {},
    codedRecords: {},
    ready: false,
    search: '',
  },
  mutations: {
    increment (state) {
      state.count++
    },

    /** 
    * Store function to update the searchbar search status.
    * @param {Object} state - Store's state.
    */
    updateSearch(state, string) {
      state.search = string;
      // console.log(state.search);
    },

    async fetchFiles(state) {
      const f01 = await d3.csv('https://storage.googleapis.com/cartografiadigital/formulario01.csv').then(file => file)
      const f02 = await d3.csv('https://storage.googleapis.com/cartografiadigital/formulario02.csv').then(file => file)
      const map = await d3.csv('https://storage.googleapis.com/cartografiadigital/mapa.csv').then(file => file)
      
      const elements = {};
      const positions = {};
      const brElements = {};

      map.forEach((row, idx) => {
        Object.entries(row).forEach((key) => {
          let [col, code] = key;
          code = code.trim();
          if ((code.startsWith('CD')) || (code.startsWith('BR'))){
            positions[code] = {
              col: parseInt(col) - 2,
              row: idx + 1
            }
          }
          else {
            // console.log(code);
          }
        })
      })
      f01.forEach(d => {
        const el = {};
        el.cc = d['Propiedad intelectual'] === 'Obra protegida/Copyright' ? 'protected' : 'cc';
        el.rawCC = d['Propiedad intelectual'];
        el.code = d['Codificación archivo'];
        try {
          el.title = d['Título'];
          el.country = d['País de producción de la obra'];
          el.year = d['Año de producción (incluir solo el año)'];
          el.genre = d['Género'];
          el.author = d['nombre del autor principal'].split(',').map(author => author.trim())
          el.format = d['Formatos en la publicación'].split(',').map(f => f.trim())
          el.techniques = d["Técnicas"].split(',').map(t => {
            return t.length > 1 ? t.trim() : t
          });
          el.column = positions[el.code].col;
          el.row = positions[el.code].row;
          elements[el.code] = el;
        } catch (error) {
          // console.log(el.code)
        }
      })
      f02.forEach(d => {
        const code = d['Codificación de archivo'];
        if (!code.startsWith('BR')){
          elements[code].url = d['URL'];
          elements[code].description = d['Descripción '];
          elements[code].colaborators = d['Colaboradores'].split(',').map(colab => colab.trim());
          elements[code].repositoryLink = d['Ir a Repositorio'];
        }
        else {
          const record = {
            title: d['Título'],
            code: code,
            author: d['Nombre del autor'],
            country: d['País de producción de la obra'],
            url: d['URL'],
            column: positions[code].col,
            row: positions[code].row
          }
          brElements[code] = record
        }
      })
      const records = {
        records: Object.entries(elements).map((key) => ({metadata: key[1]}))
      }

      const brRecords = {
        records: Object.entries(brElements).map((key) => ({metadata: key[1]}))
      }
      
      state.records = records.records;
      state.brRecords = brRecords.records;
      state.codedRecords = elements;
      state.ready = true;
    }
  },
  getters: {
    getRecords: state => state.records,
    getBrRecords: state => state.brRecords,
    getRecord: state => id => state.codedRecords[id],
    getSearch: state => state.search,
  },
})
